export const ENV = {
  SPACE_ID: process.env.REACT_APP_CONTENTFUL_SPACE_ID ?? "",
  ACCESS_TOKEN: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN ?? "",
  PREVIEW_ACCESS_TOKEN: process.env.REACT_APP_PREVIEW_ACCESS_TOKEN ?? "",
  ENVIRONMENT: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT ?? "",
  CONTENTFUL_HOST: "cdn.contentful.com",
  PREVIEW_CONTENTFUL_HOST: "preview.contentful.com",
};
